import ProviderPending from './provider-pending';

export default ProviderPending;
